import React from "react";
import styled from "styled-components";

const Page = styled.div`
  min-height: 100vh;
  padding: 118px 20px 80px;
  background:
    radial-gradient(860px at 12% 0%, rgba(245, 158, 11, 0.12), transparent 58%),
    radial-gradient(900px at 88% 6%, rgba(56, 189, 248, 0.12), transparent 60%),
    linear-gradient(180deg, #06101d 0%, #040814 100%);
`;

const Wrap = styled.div`
  max-width: 920px;
  margin: 0 auto;
`;

const Shell = styled.div`
  padding: 30px;
  border-radius: 30px;
  background: linear-gradient(180deg, rgba(8, 16, 29, 0.96), rgba(5, 11, 22, 0.92));
  border: 1px solid rgba(148, 163, 184, 0.14);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24);
`;

const Eyebrow = styled.div`
  display: inline-flex;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.16);
  color: #7dd3fc;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const Title = styled.h1`
  margin: 18px 0 10px;
  color: #f8fafc;
  font-size: clamp(2rem, 4vw, 3.3rem);
  line-height: 1.06;
`;

const Lead = styled.p`
  margin: 0;
  color: #94a3b8;
  font-size: 15px;
  line-height: 1.8;
`;

const Section = styled.section`
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
`;

const SectionTitle = styled.h2`
  margin: 0 0 12px;
  color: #f8fafc;
  font-size: 1.3rem;
`;

const Text = styled.p`
  margin: 0;
  color: #cbd5e1;
  font-size: 14px;
  line-height: 1.85;
`;

const List = styled.ul`
  margin: 12px 0 0;
  padding-left: 20px;
  color: #cbd5e1;

  li {
    margin-bottom: 10px;
    line-height: 1.8;
  }
`;

export default function TermsOfServicePage() {
  return (
    <Page>
      <Wrap>
        <Shell>
          <Eyebrow>Terms of Service</Eyebrow>
          <Title>Terms for using skilll.dev</Title>
          <Lead>
            Last updated: April 5, 2026. These terms describe how skilll.dev may
            be used, what responsibilities users have, and how access to the
            product and paid features is handled.
          </Lead>

          <Section>
            <SectionTitle>Using the service</SectionTitle>
            <Text>
              skilll.dev is provided as a roadmap, learning workflow, and
              productivity platform for learners and developers. By using the
              service, you agree to use it lawfully, respectfully, and only for
              legitimate personal or professional learning use.
            </Text>
          </Section>

          <Section>
            <SectionTitle>Accounts</SectionTitle>
            <List>
              <li>You are responsible for the accuracy of information you provide for your account.</li>
              <li>You are responsible for maintaining the security of your login credentials.</li>
              <li>You must not impersonate another person or misuse another user’s account.</li>
            </List>
          </Section>

          <Section>
            <SectionTitle>Roadmaps, AI guidance, and product features</SectionTitle>
            <List>
              <li>Roadmaps, AI suggestions, mentor guidance, and productivity tools are provided to support learning and execution, not as guaranteed career outcomes.</li>
              <li>You remain responsible for how you apply suggestions, project ideas, practice content, and planning systems.</li>
              <li>We may improve, refine, or remove features as the product evolves.</li>
            </List>
          </Section>

          <Section>
            <SectionTitle>Community and user content</SectionTitle>
            <List>
              <li>You are responsible for the content you post, including community posts, comments, notes, and support messages.</li>
              <li>You must not post illegal, abusive, misleading, infringing, or harmful material.</li>
              <li>We may remove content or restrict access if behavior violates platform rules or harms other users.</li>
            </List>
          </Section>

          <Section>
            <SectionTitle>Payments and subscriptions</SectionTitle>
            <List>
              <li>Some features may require an active paid plan.</li>
              <li>Billing, renewals, and subscription state may depend on third-party payment processors.</li>
              <li>When a paid plan is cancelled, premium access may remain until the current billing period ends, depending on the billing flow in effect.</li>
            </List>
          </Section>

          <Section>
            <SectionTitle>Availability and changes</SectionTitle>
            <Text>
              We aim to keep skilll.dev available and useful, but we do not
              guarantee uninterrupted access, error-free operation, or permanent
              availability of every feature, integration, or tool.
            </Text>
          </Section>

          <Section>
            <SectionTitle>Limitation of liability</SectionTitle>
            <Text>
              skilll.dev is provided on an as-available basis. To the maximum
              extent allowed by law, we are not liable for indirect, incidental,
              or consequential losses resulting from your use of the platform,
              third-party integrations, or decisions made using product output.
            </Text>
          </Section>

          <Section>
            <SectionTitle>Contact</SectionTitle>
            <Text>
              For questions about these terms, use your official support or
              company contact email and keep this page aligned with your launch
              support process.
            </Text>
          </Section>
        </Shell>
      </Wrap>
    </Page>
  );
}
